import { Button, Box } from "@chakra-ui/react";
import { DownloadIcon } from "@chakra-ui/icons";

const ExportCsvButton = ({ onExport }) => {
    return (
        <Box w={{ base: "100%", md: "auto" }}>
            <Button
                w={{ base: "100%", md: "fit-content" }}
                minW="140px"
                colorScheme="green"
                variant="solid"
                fontWeight="500"
                leftIcon={<DownloadIcon />}
                onClick={onExport}
            >
                Export CSV
            </Button>
        </Box>
    );
};

export default ExportCsvButton;
